import type React from 'react'
import styled from 'styled-components'

import { CircularProgress } from '@components/ui'

const LoaderContainer = styled.div`
  font-size: 14px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
`
interface LoaderProps {
  infoText: NonNullable<React.ReactNode>
}

export function Loader({ infoText }: LoaderProps) {
  return (
    <LoaderContainer>
      <CircularProgress size={20} />
      {infoText}
    </LoaderContainer>
  )
}
